
import { Component, Vue, Prop, Watch, Model  } from 'vue-property-decorator';
import { App, CustomField, CustomBar, Theme, ThemeImagesPosition, Color, Images } from '../models/App';
import '../assets/scratchy.css';
import i18n from '../plugins/i18n';
import { ICampaign } from '../models/Campaign';
import ProgressBar from '@/components/ProgressBar.vue';
import Recart from '@/components/integrations/Recart.vue';
import store from '../store/index';

interface ISlice {
    id: number;
    gravity: number;
    text: string;
    code: string;
    email: string;
    fill: string;
}

@Component({
    components: {
        ProgressBar,
        Recart
    }
})

export default class ScratchyTemplate extends Vue {
    @Prop(Object) public campaign!: ICampaign;
    @Prop(Object) public themeImages!: Images;
    @Prop(Number) public swapView!: number;
    @Prop(String) public cndUrl!: string;

    private selectedTheme: Theme = { text: '', value: '', selected: false, images: { background: '', top: '', bottom: '', pulltab: '', wheel: '' }};
    private selectedColors: Color = {
        theme: '',
        backgroundColor: { hex: '' },
        wheelFontColor: { hex: '' },
        fontColor: { hex: '' },
        buttonColor: { hex: '' },
        sliceColorSet1: { hex: '' },
        sliceColorSet2: { hex: '' },
        sliceColorSet3: { hex: '' },
        sliceColorSet4: { hex: '' },
        pointerColor: { hex: '' },
        buttonFontColor: { hex: ''}
    };
    private isDrawing: any;
    private lastPoint: any;
    private canvasWidth: any;
    private canvasHeight: any;
    private ctx: any;
    private image: any;
    private brush: any;
    private percentage: number = 60;
    // @ts-ignore
    private container: HTMLElement;
    // @ts-ignore
    private canvas: HTMLCanvasElement;
    private visible = true;
    private previewText = i18n.t('label.hide');

    private ScratchyContainer = document.getElementById('wheelio');    

    private mounted() {
        if (this.isPhoneView) {
            // @ts-ignore
            this.ScratchyContainer = document.getElementById('phone-simulator').contentWindow.document.body as HTMLElement;
        } else {
            this.ScratchyContainer = document.getElementById('wheelio');
        }

        this.applyTheme();
        const brush64: string = 'data:image/png;base64,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';
        // @ts-ignore
        this.canvas       = this.ScratchyContainer.querySelector('#js-canvas') as HTMLCanvasElement,
        this.canvasWidth  = this.canvas.width,
        this.canvasHeight = this.canvas.height,
        this.ctx          = this.canvas.getContext('2d'),
        this.image        = new Image(),
        this.brush        = new Image();
        this.brush.src = brush64;

        if (this.swapView === 0) {
            this.ScratchyContainer?.querySelector('#scr-try-luck-btn')?.addEventListener('click', this.startSpin);
        }

        this.setScratchCard()
    }
    private setScratchCard() {
        this.ctx.canvas.width = 200;
        this.ctx.canvas.height = 150;
        const myGradient = this.ctx.createLinearGradient(0, 200, 150 ,0);
        myGradient.addColorStop(0, 'rgb(170, 170, 170)');
        myGradient.addColorStop(0.3, 'rgb(229, 229, 229)');
        myGradient.addColorStop(0.5, 'rgb(170, 170, 170)');
        myGradient.addColorStop(0.7, 'rgb(230, 230, 230)');
        myGradient.addColorStop(0.8, 'rgb(228, 228, 228)');
        myGradient.addColorStop(1, 'rgb(170, 170, 170)');
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.fillStyle = myGradient;
        this.ctx.fillRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.fillStyle = this.selectedColors.fontColor.hex;
        this.ctx.fillRect(0, 0, this.ctx.canvas.width, 4);
        this.ctx.fillRect(0, 0, 4, this.ctx.canvas.height);
        this.ctx.fillRect(this.ctx.canvas.width - 4, 0, 4, this.ctx.canvas.height);
        this.ctx.fillRect(0, this.ctx.canvas.height - 4, this.ctx.canvas.width, 4);
    }
    private startSpin() {
        // @ts-ignore
        this.ScratchyContainer!.querySelector('.scratch-reward').innerHTML = this.campaign.app.coupons[0].code;
        this.ScratchyContainer!.querySelector('.scratch-card-lock')!.classList.add('wlo_animate_out_long');
        setTimeout(() => {
            this.ScratchyContainer!.querySelector('.scratch-card-lock')!.classList.add('scr-hidden');
        }, 1000);
        this.ScratchyContainer!.querySelector('#wl_custom_fields_holder')!.classList.add('wlo_animate_out');
        this.ScratchyContainer!.querySelector('#scr-try-luck-btn')!.classList.add('wlo_animate_out');
        this.ScratchyContainer!.querySelector('.scr-texts')!.classList.add('wlo_animate_out');
        setTimeout(() => {
            this.ScratchyContainer!.querySelector('.scr-texts')!.classList.add('scr-hidden');
            // this.AppContainer.querySelector("#scr-try-luck-btn").classList.add("scr-hidden");
            this.ScratchyContainer!.querySelector('#wl_custom_fields_holder')!.classList.add('scr-hidden');
            this.ScratchyContainer!.querySelector('.scr-congratulations')!.classList.remove('scr-hidden');
        }, 300);
    }

    private Collect() {
        // @ts-ignore
        store.commit('showSuccessSnackbar', this.campaign.app.texts.copiedMessage);
    }

    @Watch('themeImages', { deep: true })
    private onAppSelectedImagesChanged() {
        this.applyTheme();
    }

    get invertColor() {
        const hex = this.selectedColors.backgroundColor.hex.replace('#', '');
        const C_R = parseInt(hex.substr(0, 2), 16);
        const C_G = parseInt(hex.substr(2, 2), 16);
        const C_B = parseInt(hex.substr(4, 2), 16);
        const brightness = ((C_R * 299) + (C_G * 587) + (C_B * 114)) / 1000;
        return brightness < 200;
    }

    private handleMouseDown(e?: MouseEvent) {
        this.isDrawing = true;
        this.lastPoint = this.getMouse(e);
    }

    private handleMouseMove(e?: MouseEvent) {
        if (!this.isDrawing) { return; }

        e!.preventDefault();
        const currentPoint = this.getMouse(e);
        const dist = this.distanceBetween(this.lastPoint, currentPoint);
        const angle = this.angleBetween(this.lastPoint, currentPoint);
        let x;
        let y;

        for (let i = 0; i < dist; i++) {
          x = this.lastPoint.x + (Math.sin(angle) * i) - 25 - window.innerWidth + 400;
          y = this.lastPoint.y + (Math.cos(angle) * i) - 25 - window.innerHeight / 2;
          this.ctx.globalCompositeOperation = 'destination-out';
          this.ctx.drawImage(this.brush, x, y);
        }

        this.lastPoint = currentPoint;
        this.handlePercentage(this.getFilledInPixels(32));
    }

    private handleMouseUp = (_e?: Event) => {
        this.isDrawing = false;
    }

    private getMouse(e?: MouseEvent) {
        let mx;
        let my;

        const offsetY = (window.outerHeight-1100)/2
        // @ts-ignore
        mx = e!.pageX + document!.getElementById('main-content').offsetLeft - (this.brush.width/4);
        my = e!.pageY + offsetY - (this.brush.height/4);

        return {x: mx, y: my};
    }

    private distanceBetween(point1: any, point2: any) {
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    }

    private angleBetween(point1: any, point2: any) {
        return Math.atan2( point2.x - point1.x, point2.y - point1.y );
    }

    private getFilledInPixels(stride: any) {
        if (!stride || stride < 1) { stride = 1; }

        const pixels   = this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight);
        const pdata    = pixels.data;
        const l        = pdata.length;
        const total    = (l / stride);
        let count      = 0;

        for (let i = count = 0; i < l; i += stride) {
          if (parseInt(pdata[i], 10) === 0) {
            count++;
          }
        }

        return Math.round((count / total) * 100);
    }

    private handlePercentage(filledInPixels: any) {
        filledInPixels = filledInPixels || 0;
        if (filledInPixels > this.percentage) {
            // @ts-ignore
            const coupon = this.campaign.app.coupons[0];
            this.canvas.parentNode!.removeChild(this.canvas);
        }
    }

    private applyTheme() {
        // @ts-ignore
        const wheelio = this.ScratchyContainer.querySelector('#panel');
        // @ts-ignore
        const wheelHolder = this.ScratchyContainer.querySelector('.scratch-card-holder');
        // @ts-ignore
        const logo = this.ScratchyContainer.querySelector('.scratchy_logo');
        // @ts-ignore
        this.selectedTheme = this.campaign.app.themes.findWith('selected', true);
        const selectedThemeValue = this.selectedTheme.origin != null && this.selectedTheme.origin !== '' ? this.selectedTheme.origin : this.selectedTheme.value;
        // @ts-ignore
        this.selectedColors = this.campaign.app.colors.findWith('theme', this.selectedTheme.value);

        if (wheelio !== null) {
            // remove existing elements
            // @ts-ignore
            const themeItems = Array.from(this.ScratchyContainer.querySelectorAll('.theme-item'));
            themeItems.forEach((el) => {
                el.remove();
            });
            wheelio.classList.remove('wlo_christmas_snow');
            if (logo != null && logo !== undefined) {
                logo.classList.remove('wlo_stpatric');
            }

            // add new elements
            const theme: ThemeImagesPosition[] = [
                { type: 'bg', value: this.themeImages.background },
                { type: 'bottom', value: this.themeImages.bottom },
                { type: 'pulltab', value: this.themeImages.pulltab },
                { type: 'top', value: this.themeImages.top },
                { type: 'wheel', value: this.themeImages.wheel },
            ];
           
            theme.forEach((el) => {
                if (el.value !== '' && el.value !== null) {
                    if (!el.value.startsWith("http")) {
                        el.value = `${this.cndUrl}/${el.value}`;
                    }

                    const div = document.createElement('img');
                    div.classList.add('wlo_' + selectedThemeValue + '_' + el.type, 'theme-item');
                    div.setAttribute('src', el.value);
                    if (selectedThemeValue === 'christmas') {                    
                        wheelio.classList.add('wlo_christmas_snow');
                    }
                    switch (el.type) {
                        case 'bg': {
                            const bg = document.createElement('div');
                            bg.classList.add('wlo_' + selectedThemeValue + '_' + el.type, 'theme-item');
                            bg.setAttribute('style', 'background-image: url(' + el.value + ');');
                            wheelio.prepend(bg);
                            break;
                        }
                        case 'bottom': {
                            wheelio.prepend(div);
                            break;
                        }
                        case 'pulltab': {
                            if (selectedThemeValue !== 'christmas') {
                                wheelio.prepend(div);
                            } 
                            break;
                        }
                        case 'top': {
                            wheelio.prepend(div);
                            break;
                        }
                        case 'wheel': {
                            if (wheelHolder !== null) {
                                wheelHolder.prepend(div);
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
            });

            if (selectedThemeValue === 'stpatric' && logo != null && logo !== undefined) {
                logo.classList.add('wlo_stpatric');
            }
        }
    }

    private getInputClass(type: string) {
        if (type === 'text') {
            return 'wlo_email_input';
        } else if (type === 'checkbox') {
            return 'wlo_checkbox wlo_hidden';
        } else {
            return '';
        }
    }

    get isPhoneView() {
        return document.getElementById('phone-simulator') != null;
    }

    get gdprEnable() {
        return this.campaign.app?.gdprEnable;
    }

    @Watch('selectedColors.fontColor')
    private onFontColorChange() {
        this.setScratchCard();
    }
}
